import { Button, styled, Typography } from '@mui/material';
import { NavLink } from 'react-router-dom';

export const PreviewSection = styled('div')`
  margin-bottom: 24px;
  background-color: #fbfbfb;
  backdrop-filter: blur(20px);
  border-radius: 15px;
  min-height: 200px;
  margin-top: 32px;

  @media (max-width: 1023px) {
    padding: 0px 11px 23px;
    margin-top: 0px;
  }
`;

export const HeaderW = styled('div')`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
`;

export const SectionTitle = styled(Typography)`
  font-weight: 700;
  font-size: 24px;
  line-height: 32px;
  margin-bottom: 16px;

  @media (max-width: 1023px) {
    display: none;
  }
`;

export const InnerContainer = styled('div')`
  border: ${({ theme }) => `1px solid ${theme.palette.primary.grey}`};
  background: ${({ theme }) => theme.palette.white.main};
  margin-top: 40px;
  border-radius: 8px;
  width: 100%;
  height: 100%;
  padding: 16px;

  @media (max-width: 1023px) {
    margin-top: 16px;
  }
`;

export const CreateButton = styled(Button)`
  text-transform: none;
  font-weight: 500;
  font-size: 14px;
  line-height: 14px;
  border-radius: 8px;
  padding: 6px 12px;
  background-color: ${({ theme }) => theme.palette.info.main};

  @media (max-width: 1023px) {
    width: 100%;
  }
`;

export const SeeMoreLink = styled(NavLink)`
  display: block;
  text-align: right;
  margin-top: 8px;
  font-size: 14px;
  font-weight: 500;
  color: ${({ theme }) => theme.palette.primary.p080};
  text-decoration: underline;
  text-underline-offset: 2px;

  &:hover {
    opacity: 0.7;
  }
`;
